import React, { ReactNode } from 'react'
import TooltipLabel from './TooltipLabel'

export const errorId = (name: string) => `${name}-error`

const FieldFrame = ({
  name,
  label,
  tooltip,
  error,
  children
}: {
  name: string
  label?: string
  tooltip?: string
  error?: string
  children: ReactNode
}) => (
  <div className="form-group">
    {label && (
      <label htmlFor={name}>
        <TooltipLabel text={label} tooltip={tooltip} />
      </label>
    )}
    {children}
    {error && (
      <div id={errorId(name)} className="invalid-feedback d-block">
        {error}
      </div>
    )}
  </div>
)

export default FieldFrame
